import React from 'react';
import PropTypes from 'prop-types';

const ChevronDown = props => {
  const { id, ...rest } = props;

  return (
    <svg
      id={id}
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M18.7 9.7l-6 6c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-6-6c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l5.3 5.3 5.3-5.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
        id={`${id}-path`}
      />
    </svg>
  );
};

ChevronDown.propTypes = {
  id: PropTypes.string,
};

ChevronDown.defaultProps = {
  id: 'chevron-down',
};

export default ChevronDown;
